import Card from './card-TEMPLATE_VERSION'

export default Card
